// TODO: Implement real comments — currently placeholder with hardcoded data
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Avatar, AvatarImage } from '@codes/ui-kit/components/ui/avatar';
import { Button } from '@codes/ui-kit/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@codes/ui-kit/components/ui/dropdown-menu';
import { EllipsisVertical, Heart, MessageCircle } from 'lucide-react';

import EmptyUserIcon from '/assets/icons/user.svg';

export interface CommentsSectionProps {
    onReport?: () => void;
    onDelete?: () => void;
    onSubmitComment?: (comment: string) => void;
}

export const CommentsSection: React.FC<CommentsSectionProps> = ({ onReport, onDelete, onSubmitComment }) => {
    const { t } = useTranslation();

    return (
        <div className="h-full bg-card shadow-custom border border-chatbot-line rounded-2xl overflow-hidden flex flex-col py-6 px-6 max-md:max-h-[50vh] max-md:overflow-auto">
            <div className="flex-1 flex flex-col overflow-hidden">
                <div className="text-lg font-medium mb-6 whitespace-pre-line">{t('agent.chat.reviewPrompt')}</div>
                <div className="flex items-center gap-1 text-sub text-sm font-medium bg-box dark:bg-hover py-[5px] px-[9px] rounded-md">
                    <MessageCircle className="w-4 h-4 text-point" />2{t('agent.chat.commentCount')}
                </div>
                <ul className="flex-1 h-full overflow-auto">
                    <li className="border-b border-border dark:border-border py-4">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <Avatar className="w-6 h-6 bg-box border border-chatbot-line p-0">
                                    <AvatarImage src={EmptyUserIcon} />
                                </Avatar>
                                <div className="text-xs font-medium ml-[6px]">{t('agent.chat.anonymousUser')}</div>
                                <div className="text-[10px] text-text-500">・</div>
                                <div className="text-[10px] text-text-500">10{t('agent.chat.minute')}</div>
                            </div>
                            <DropdownMenu>
                                <DropdownMenuTrigger className="group" onClick={e => e.stopPropagation()}>
                                    <EllipsisVertical className="w-4 h-4 text-sub group-hover:text-icon-hover" />
                                </DropdownMenuTrigger>
                                <DropdownMenuContent
                                    align="end"
                                    className="min-w-[108px] px-3 py-1.5 rounded-lg outline-none"
                                >
                                    <DropdownMenuItem
                                        className="text-xs justify-center"
                                        onClick={e => {
                                            e.stopPropagation();
                                            onReport?.();
                                        }}
                                    >
                                        {t('agent.chat.report')}
                                    </DropdownMenuItem>
                                    <DropdownMenuSeparator className="my-[6px] bg-box"></DropdownMenuSeparator>
                                    <DropdownMenuItem
                                        className="text-xs justify-center text-error focus:text-error"
                                        onClick={e => {
                                            e.stopPropagation();
                                            onDelete?.();
                                        }}
                                    >
                                        {t('agent.chat.delete')}
                                    </DropdownMenuItem>
                                </DropdownMenuContent>
                            </DropdownMenu>
                        </div>
                        <div className="mt-1 text-xs">
                            Lorem ipsum dolor sit amet consectetur. Amet tortor donec dolor diam eget amet pretium
                            cursus aliquam.
                        </div>
                        <div className="mt-2">
                            <Heart className="w-4 h-4 text-sub cursor-pointer" strokeWidth={1.5} />
                        </div>
                    </li>
                </ul>
            </div>

            <div className="mt-auto sticky bottom-0 bg-card pt-3.5">
                <div className="h-[42px] flex items-center justify-between gap-1 px-[10px] border border-chatbot-line rounded-lg overflow-auto">
                    <input
                        className="flex-1 text-sm outline-0 bg-transparent"
                        type="text"
                        placeholder={t('agent.chat.placeholder')}
                    />
                    <Button size="sm" className="h-[26px]">
                        {t('agent.chat.submit')}
                    </Button>
                </div>
            </div>
        </div>
    );
};
